import { CLEAR_SITE_DATA } from '../application';
import {
  RECEIVE_SOURCES,
  RESET_SOURCES,
  RECEIVE_SYNC_HEALTH,
  RECEIVE_CONNECTIVITY,
  RECEIVE_VARIABLE,
  REMOVE_VARIABLE,
  RECEIVE_SITE_VARIABLES,
} from './actions';
// Uncomment if enabling on-prem support for risk panel config import
// import config from '../../config';

const initialState = {
  sources: [],
  sourceTypes: [],
  siteVariablesIndex: {},
  injectableSourceTypes: ['elasticsearch'],
  importableSourceTypes: ['custom', 'dec', 'identiq-ts'],
  syncedSourceTypes: ['dec'],
  siteLoaded: undefined,
  syncHealth: {},
  siteVariablesUpdatedAt: 0,
  sourceConnectivity: [],
  sourcesUpdatedAt: 0,
};

// Uncomment if enabling on-prem support for risk panel config import
// if (config.onPremise) {
//   initialState.injectableSourceTypes.push('identiq');
// }

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case RECEIVE_SOURCES: {
      return {
        ...state,
        sources: action.sources,
        sourceTypes: action.sourceTypes,
        siteVariablesIndex: action.siteVariablesIndex || state.siteVariablesIndex,
        siteLoaded: action.siteId,
        sourcesUpdatedAt: action.sourcesUpdatedAt,
        siteVariablesUpdatedAt: action.siteVariablesUpdatedAt || state.siteVariablesUpdatedAt,
      };
    }
    case RECEIVE_SYNC_HEALTH: {
      const { syncHealth, siteId } = action;

      return {
        ...state,
        syncHealth: {
          ...state.syncHealth,
          [siteId]: syncHealth,
        },
      };
    }
    case RECEIVE_VARIABLE: {
      return {
        ...state,
        siteVariablesIndex: {
          ...state.siteVariablesIndex,
          [action.variable.id]: action.variable,
        },
        siteVariablesUpdatedAt: action.siteVariablesUpdatedAt,
      };
    }
    case REMOVE_VARIABLE: {
      const variableIndexCopy = { ...state.siteVariablesIndex };
      delete variableIndexCopy[action.variableId];
      return {
        ...state,
        siteVariablesIndex: variableIndexCopy,
        siteVariablesUpdatedAt: action.siteVariablesUpdatedAt,
      };
    }
    case RECEIVE_SITE_VARIABLES: {
      return {
        ...state,
        siteVariablesIndex: action.siteVariablesIndex,
        siteVariablesUpdatedAt: action.siteVariablesUpdatedAt,
      };
    }
    case RECEIVE_CONNECTIVITY: {
      return {
        ...state,
        sourceConnectivity: action.sourceConnectivity || [],
      };
    }
    case RESET_SOURCES:
    case CLEAR_SITE_DATA: {
      return structuredClone(initialState);
    }
    default: {
      return state;
    }
  }
}
